module.exports = __webpack_public_path__ + "static/media/body_trend.193670f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/intro-2/body_trend.png
// module id = 690
// module chunks = 0